import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import { getReviseRoutineApi } from "../../services/reviseRoutine.service";
import ReviseRoutineComponent from "../../components/revise-routine/ReviseRoutineComponent";
import PageLoader from "../../components/common/loader/pageLoader";
import { getSkinProfileApi } from "../../services/skinProfile.service";
import { routineStatus } from "../../store/slice/profile.slice";
interface ReviseRoutineContainerProps {}

interface ReviseRoutineData {
  product_id: number;
  [key: string]: any;
}

const ReviseRoutineContainer: React.FC<ReviseRoutineContainerProps> = () => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ReviseRoutineData | undefined>();
  const profile = useAppSelector((state) => state?.profile);
  const { survey_id } = profile;
  useEffect(() => {
    // setLoading(true);
    if (survey_id) {
      fetchSkinProfile();
    }
  }, [survey_id]);

  const fetchSkinProfile = () => {
    setLoading(true);
    dispatch(
      // getSkinProfileApi({
      //   finalCallback: () => {
      //     setLoading(false);
      //   },
      //   successCallback: (data: any) => {
      //     dispatch(routineStatus(data?.routine_status || {}));
      //   },
      //   unAunthicatedCallback: () => {},
      // })
      getReviseRoutineApi({
        finalCallback: () => {
          setLoading(false);
        },
        successCallback: (data: any) => {
          setData(data);
        },
        unAunthenticatedCallback: () => {},
      })
    );
  };
  if (loading) {
    return <PageLoader />;
  }

  return <ReviseRoutineComponent data={data} />;
};

export default ReviseRoutineContainer;
